import collect from 'collect.js'

const userSelectedRole = state => {
  if (!state.userSelected) {
    return null
  }
  let user = _.clone(state.userSelected)
  user.roles = user.roles.map(item => item.name)
  return user
}

const listById = state => _.keyBy(state.list, 'id')

const findById = (state, getters) => id => _.clone(getters.listById[id])

const seeders = state => {
  if (!state.list) {
    return []
  }
  return collect(state.list).filter(o => o.roles.includes('Seeder'))
}

export default {
  userSelectedRole, listById, findById , seeders
}



// WEBPACK FOOTER //
// ./src/features/User/store/getters.js